import { request } from '@/utils/ajax';
import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { BygrModule, getCoreApiUrl, WhiteLabelDto } from '@ygtechnologies/bygr-frontend-component-library';

export function getWhiteLabelLogoUrl(projectId: number): string {
    return getCoreApiUrl() + `/api/project/${projectId}/white-label-logo`;
}

export function deleteWhiteLabelLogo(projectId: number): Promise<void> {
    return request(getCoreApiUrl() + `/api/project/${projectId}/white-label-logo`, {
        method: 'DELETE',
        query: { bygrModule: BygrModule.ChangeManagement },
    }).then((x) => {});
}

export function getWhiteLabelLogoThumbnailUrl(projectId: number): string {
    return getCoreApiUrl() + `/api/project/${projectId}/white-label-logo/thumbnail`;
}

export function getProjectWhiteLabel(projectId: number): Promise<WhiteLabelDto> {
    return request(`${getCoreApiUrl()}/api/project/${projectId}/white-label`).then((x) => x.json());
}

export function saveProjectWhiteLabel(
    projectId: number,
    whiteLabelData: WhiteLabelDto,
    logo: FileData | null
): Promise<WhiteLabelDto> {
    if (whiteLabelData.themeJson) {
        return request(`${getCoreApiUrl()}/api/project/${projectId}/white-label/v2`, {
            method: 'POST',
            body: {
                themeJson: whiteLabelData.themeJson,
                isEnabled: whiteLabelData.isEnabled,
                logo,
            },
            json: true,
        }).then((x) => x.json());
    }
    return request(`${getCoreApiUrl()}/api/project/${projectId}/white-label`, {
        method: 'POST',
        body: { ...whiteLabelData, logo },
        json: true,
    }).then((x) => x.json());
}
